import { IconRefresh } from "@tabler/icons-react"
import { useState } from "react"

import { cn } from "@forento/ui/utilities/tailwind"

import Button from "~/components/Button"
import { isConnectionError } from "~/utilities/connectivity"

export default function LoadingError({
	error,
	subject,
	onRetry,
	fullPage = false,
}: {
	error: unknown
	subject: string
	onRetry(): Promise<unknown>
	fullPage?: boolean
}) {
	const [retrying, setRetrying] = useState(false)
	async function retry() {
		setRetrying(true)
		try {
			await onRetry()
		} catch {
			// Keep the retry available if an imperative caller rejects.
		} finally {
			setRetrying(false)
		}
	}
	return (
		<div
			className={cn(
				"flex flex-col items-center justify-center gap-3 p-8 text-center",
				fullPage && "min-h-screen",
			)}
		>
			<div role="status">
				<p className="font-semibold">We couldn't load {subject}.</p>
				<p className="text-light mt-1 text-sm">
					{isConnectionError(error)
						? "Check your connection and try again."
						: "Please try again in a moment."}
				</p>
			</div>
			<Button variant="secondary" onClick={retry} isLoading={retrying}>
				<IconRefresh className="size-4" aria-hidden />
				Try again
			</Button>
		</div>
	)
}
